// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.base-height[data-v-73ef8212] {\n        min-height: calc(100vh - 128px)\n}\n@media screen and (max-width: 768px) {\n.container[data-v-73ef8212] {\n            padding: 0 1rem;\n}\n.base-height[data-v-73ef8212] {\n            min-height: auto;\n}\n.box-texto[data-v-73ef8212] {\n            margin-top: 0!important\n}\n}\n", ""]);
// Exports
module.exports = exports;
